import React from "react"

const Contact = () => {
  return (
    <div>
      <h1 style={{ display: "flex", justifyContent: "center" }}>Contact</h1>
      <p style={styles.text}>
        Thank you for visiting YummyPi Recipes! To provide feedback, report a
        bug, or general inquiries please contact our team via email at{" "}
        <a href="mailto:YummyPiRecipes@gmail.com" style={styles.link}>
          YummyPiRecipes@gmail.com
        </a>
        .
      </p>
    </div>
  )
}

const styles = {
  text: {
    textAlign: "center",
    fontSize: "18px",
    color: "#333",
    lineHeight: "1.6",
  },
}

export default Contact
